import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useVote } from './hooks/useVote';

import { Title } from './components/Title/Title';
import { Prize } from './components/Prize/Prize';
import { MessagesList } from './components/MessagesList/MessagesList';
import { BgVideo } from './components/BgVideo/BgVideo';

const stageSlowS = 'S2';
const stageFastS = 'S3';
const stageWinnerS = 'S4';
const stageСleaningS = 'S5';

const stagesS = {
  stageSlowS,
  stageFastS,
  stageWinnerS,
  stageСleaningS,
};

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, winnerMessage, speed } = useCarousel(stagesS);

  const isWinnerStage = currentState === stageWinnerS;

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      {currentState && <Title isWinnerStage={isWinnerStage} />}

      {currentState && (
        <div className="presentBlock">
          <Prize voteState={voteState} />
        </div>
      )}

      <AnimatePresence mode="wait">
        {[stageSlowS, stageFastS, stageWinnerS].includes(currentState) && (
          <motion.div
            key="rnd"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="motion"
            style={{ display: 'flex' }}
          >
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              isWinnerStage={isWinnerStage}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <BgVideo />

      <div id="img-loader" />
    </div>
  );
}

export default App;
